import AdminEntity from "../../components/admin/AdminEntity";

export default function AdminRoomsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "Rooms",
      title: "Room types & pricing",
      testidPrefix: "admin-rooms",
      singular: "room",
      addLabel: "New room",
      listEndpoint: "/rooms",
      keyField: "slug",
      columns: [
        { key: "order", label: "#" },
        { key: "name", label: "Name", render: (r) => <span className="font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>{r.name}</span> },
        { key: "price_from", label: "From", render: (r) => `$${r.price_from.toFixed(2)}` },
        { key: "bed_config", label: "Bed" },
        { key: "max_guests", label: "Max" },
        { key: "is_flagship", label: "Flagship", render: (r) => r.is_flagship ? "★" : "" },
      ],
      createEndpoint: "/rooms",
      updateEndpoint: (r) => `/rooms/${r.slug}`,
      deleteEndpoint: (r) => `/rooms/${r.slug}`,
      fields: [
        { name: "slug", label: "Slug", required: true, help: "URL fragment, e.g. jacuzzi-suite" },
        { name: "name", label: "Name", required: true },
        { name: "tagline", label: "Tagline", required: true },
        { name: "description", label: "Description", type: "textarea", required: true },
        { name: "price_from", label: "Price from (USD)", type: "number", required: true },
        { name: "max_guests", label: "Max guests", type: "number", required: true, defaultValue: 2 },
        { name: "bed_config", label: "Bed configuration", required: true },
        { name: "size_sqft", label: "Size (sqft)", type: "number" },
        { name: "features", label: "Features", type: "tags", help: "Comma-separated list" },
        { name: "photos", label: "Photo paths", type: "tags", help: "Comma-separated, e.g. /images/room-king-1.jpg" },
        { name: "hero_photo", label: "Hero photo path", required: true, help: "/images/…" },
        { name: "category", label: "Category", required: true, help: "room-king, room-jacuzzi, etc." },
        { name: "order", label: "Sort order", type: "number", defaultValue: 0 },
        { name: "is_flagship", label: "Flagship room", type: "boolean", checkboxLabel: "Mark as flagship" },
      ],
    }} />
  );
}
